import FormErrorMessage from '@/features/form/components/ErrorMessage'
import { useFormAddressFieldValue } from '@/features/pos/components/CustomerProfile/form'
import {
    FormAddressKeys,
    FormKeys,
} from '@/features/pos/components/CustomerProfile/form/constants/keys'
import ValidationMessage from '@/features/pos/components/CustomerProfile/parts/FormContent/parts/ValidationMessage'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const AddressValidationMessage: FC = () => {
    const address = useFormAddressFieldValue()
    const { t } = useTranslation()

    if (address.isValid === true) {
        return (
            <ValidationMessage
                message={t('pos.customerProfile.formField.address.availability.available', {
                    zone: address.zone,
                })}
                status="success"
            />
        )
    }

    return (
        <FormErrorMessage
            name={FormKeys.Address}
            pathPriority={[FormAddressKeys.Address, FormAddressKeys.isValid]}
            render={(message) => <ValidationMessage message={t(message as any)} status="error" />}
        />
    )
}

export default AddressValidationMessage
